<template>
  <div class="contact-us full-screen">
    <div class="wrapper- wrapper-full-page- section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">You've found a loophole</h2>
              <h3 class="title"><i class="fas fa-bullhorn"></i> &nbsp; But it seems that this page doesn't lead anywhere</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}

</script>



// WEBPACK FOOTER //
// NotFound.vue?09eafe79